import React from "react";
import { getTransformedId } from "@qlik/qlik/src/lib/util/format";
import Cta from "@qlik/qlik/src/components/Cta";
import { filterValidCta, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import SingleIconCard from "../../Card/Single-Icon-Card";
import * as styles from "./styles.module.css";

/**
 * cardBorderShadow component
 * @param {Object} data - The data for the cardBorderShadow
 * @returns {JSX.Element} - The cardBorderShadow component
 */
const CardBorderWithShadow = ({ data }) => {
    // Destructuring the data object to get the required properties
    const { id, customId, title, cardItems = [], cta = [], additionalConfiguration, numberOfColumns } = data ?? {};
    const ctaList = filterValidCta(cta);

    // Get the class name for the section padding
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "");
    const { sectionColorMapping } = getColorClassName(data?.backgroundColor);
    return (
        <section
            data-section
            id={customId ?? id}
            className={`py-12.5 lg:pt-30 lg:pb-20 scroll-mt-45 ${styles.cardBorderShadow} ${sectionSpacingClassName} ${sectionColorMapping.bgColor}`}
        >
            <div className="container">
                {title && (
                    <div className="row">
                        <div className="col-12 mb-5 md:mb-14.5">
                            <h2
                                className={`text-center mb-2.5 md:mb-5 ${sectionColorMapping.primaryTextColor}`}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                            />
                        </div>
                    </div>
                )}

                <div
                    className={`grid ${
                        numberOfColumns === null
                            ? "md:grid-cols-3"
                            : `md:grid-cols-2 lg:grid-cols-${numberOfColumns || 3}`
                    } md:gap-x-7.5 md:gap-y-2.5`}
                >
                    {cardItems?.map((cardItem) => (
                        <div className={`mb-5 ${styles.cardItem}`} key={cardItem.id}>
                            <SingleIconCard data={cardItem} />
                        </div>
                    ))}
                </div>

                {ctaList?.length > 0 && (
                    <div className="row pt-7.5 md:pt-15">
                        <div className="col-12 mb-2.5">
                            {ctaList?.map((linkData, index) => (
                                <Cta
                                    key={linkData.id}
                                    data={linkData}
                                    className={`block mb-7.5 mx-auto ${index === 0 ? "" : "md:text-md text-center"}`}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default CardBorderWithShadow;
